import styled from 'styled-components';
import { FORMWIDTH } from '../FormSteps.styles';

export const TablesDateContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
`;

export const TablesContainer = styled.div`
  height: fit-content;
  max-width: ${FORMWIDTH}px;
  width: ${FORMWIDTH}px;
  padding: 28px 24px;
  justify-self: center;

  @media screen and (max-width: 1280px) {
    width: calc(100vw * 0.75);
    max-width: calc(100vw * 0.75);
    padding: 20px;
  }

  @media screen and (max-width: 768px) {
    width: 100vw;
    max-width: 100vw;
    padding: 20px;
  }
`;

export const TablesWrapper = styled.div`
  width: 100%;
  display: grid;
  margin-top: 10px;
`;
